import config from "@config/config";
import ApiService from "./api";

const buildPersonsQuery = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") {
      return;
    }

    searchParams.append(key, String(value));
  });

  const query = searchParams.toString();
  return query ? `?${query}` : "";
};

class ProfileApi extends ApiService {
  constructor() {
    if (ProfileApi.instance) {
      return ProfileApi.instance;
    }

    super(config.accountApiUrl);
    ProfileApi.instance = this;
  }

  async getProfileByUserId(accountId, userId, options = {}) {
    const query = buildPersonsQuery({
      userId,
      ...(options.populateAttributes && { populateAttributes: true }),
      ...(options.masked && { masked: true }),
    });
    const response = await this.http.get(
      `/accounts/${accountId}/persons${query}`,
    );
    return response.data;
  }

  async getProfileByExUserId(accountId, externalUserId, options = {}) {
    const query = buildPersonsQuery({
      externalUserId,
      ...(options.populateAttributes && { populateAttributes: true }),
      ...(options.masked && { masked: true }),
    });
    const response = await this.http.get(
      `/accounts/${accountId}/persons${query}`,
    );
    return response.data;
  }

  async getProfilesByUserIds(accountId, userIds, options = {}) {
    const query = buildPersonsQuery({
      userIds: JSON.stringify(userIds),
      ...(options.populateAttributes && { populateAttributes: true }),
      ...(options.masked && { masked: true }),
    });
    const response = await this.http.get(
      `/accounts/${accountId}/persons/userIds${query}`,
    );
    return response.data;
  }

  async getProfileById(accountId, id, withAttr = false, masked = false) {
    const query = buildPersonsQuery({
      ...(withAttr && { populateAttributes: true }),
      ...(masked && { masked: true }),
    });
    const response = await this.http.get(
      `/accounts/${accountId}/persons/${id}${query}`,
    );
    return response.data;
  }

  async updateProfileById(accountId, id, data) {
    const response = await this.http.put(
      `/accounts/${accountId}/persons/${id}`,
      data,
    );
    return response.data;
  }

  async getProfilesByType(
    accountId,
    type,
    isEligibleRouteToApplyAnonymousPicture = false,
    journalTypeId = null,
    populateAttributes = false,
  ) {
    const query = buildPersonsQuery({
      type,
      isEligibleRouteToApplyAnonymousPicture,
      ...(journalTypeId && { journalTypeId }),
      ...(populateAttributes && { populateAttributes: true }),
    });
    const response = await this.http.get(
      `/accounts/${accountId}/persons${query}`,
    );
    return response.data;
  }

  async getAllPersons(accountId, withAttr = false, masked = false) {
    const query = buildPersonsQuery({
      ...(withAttr && { populateAttributes: true }),
      ...(masked && { masked: true }),
    });
    const response = await this.http.get(
      `/accounts/${accountId}/persons${query}`,
    );
    return response.data;
  }

  async createProfile(accountId, data) {
    const response = await this.http.post(
      `/accounts/${accountId}/persons`,
      data,
    );
    return response.data;
  }

  async getProfileAttributesByPersonId(accountId, personId) {
    const response = await this.http.get(
      `/accounts/${accountId}/persons/${personId}/attributes`,
    );
    return response.data;
  }

  async createProfileAttribute(accountId, personId, data) {
    const response = await this.http.post(
      `/accounts/${accountId}/persons/${personId}/attributes`,
      data,
    );
    return response.data;
  }

  async updateProfileAttribute(accountId, personId, attributeId, data) {
    const response = await this.http.put(
      `/accounts/${accountId}/persons/${personId}/attributes/${attributeId}`,
      data,
    );
    return response.data;
  }
}

const profileApiInstance = new ProfileApi();
export default profileApiInstance;
